/*
 * @Author: zhaozhuo
 * @Date: 2022-02-28 17:21:11
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2024-01-08 10:56:07
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\router\doctorRoute.js
 */
export default [
  {
    path: '/main',
    redirect: '/doctorResearchList'
  },
  {
    path: '/research',
    redirect: '/doctorResearchList'
  },
  {
    path: '/doctorResearchList',
    name: 'DoctorResearchList',
    meta: {
      isDoctor: true,
      keepAlive: true,
      isGetResearch: true,
      isFooter: true,
      setMenuActive: 0
    },
    component: (resolve) => require(['../views/research1/index.vue'], resolve) // 研究列表
  },
  {
    path: '/centerList',
    name: 'CenterList',
    meta: {
      isDoctor: true,
      isGetResearch: true,
      isNavBar: true,
      isResearchName: true,
      routerIconType: 1,
      isFooter: true,
      setMenuActive: 0
    },
    component: (resolve) => require(['../views/center/index.vue'], resolve) // 中心列表
  },
  {
    path: '/testeeList',
    name: 'TesteeList',
    meta: {
      isDoctor: true,
      keepAlive: false,
      isGetResearch: true,
      isNavBar: true,
      isHasComponent: true,
      routerIconType: 2,
      isFooter: true,
      setMenuActive: 0
    },
    component: (resolve) => require(['../views/testee/index.vue'], resolve) // 受试者列表
  },
  {
    path: '/doctorTesteeList',
    name: 'DoctorTesteeList',
    meta: {
      isDoctor: true,
      keepAlive: true,
      isGetResearch: true,
      isNavBar: true,
      isHasComponent: true,
      routerIconType: 2
      // isFooter: true,
      // setMenuActive: 0
    },
    component: (resolve) => require(['../views/testee/index.vue'], resolve) //  医生关联患者 --- 查看受试者列表
  },
  {
    path: '/doctorVisitList',
    name: 'DoctorVisitList',
    meta: {
      isDoctor: true,
      isGetResearch: true,
      isNavBar: true,
      isHasComponent: true,
      routerIconType: 3,
      isFooter: true,
      setMenuActive: 0
    },
    component: (resolve) =>
      require(['../views/visit/doctorVisitList/index.vue'], resolve) // 访视列表
  },
  {
    path: '/doctorFormList',
    name: 'DoctorFormList',
    meta: {
      isDoctor: true,
      isGetResearch: true,
      isNavBar: true,
      routerIconType: 4,
      isFooter: true,
      setMenuActive: 0
    },
    component: (resolve) =>
      require(['../views/form/doctorFormList/index.vue'], resolve) // 表单列表
  },
  {
    path: '/doctorFormDetail',
    name: 'DoctorFormDetail',
    meta: {
      isDoctor: true,
      isGetResearch: true,
      isNavBar: false,
      isHasComponent: true,
      routerIconType: 5
    },
    component: (resolve) =>
      require(['../views/form/formDetail/index.vue'], resolve) // 表单详情
  },
  {
    path: '/formDetail',
    name: 'FormDetail',
    meta: {
      isDoctor: true,
      isGetResearch: true,
      isNavBar: true,
      isHasComponent: true,
      routerIconType: 5,
      isHideGoBack: true
    },
    component: (resolve) =>
      require(['../views/form/formDetail/index.vue'], resolve) // 实际的表单详情
  },
  {
    path: '/doctorMessage',
    name: 'DoctorMessage',
    meta: {
      isDoctor: true,
      isGetResearch: true,
      isFooter: true,
      isEffectToken: true,
      setMenuActive: 1
    },
    component: (resolve) => require(['../views/message/index.vue'], resolve) // 消息
  },
  {
    path: '/doctorMine',
    name: 'DoctorMine',
    meta: {
      isDoctor: true,
      isGetResearch: true,
      isFooter: true,
      isEffectToken: true,
      setMenuActive: 2
    },
    component: (resolve) => require(['../views/mine/index.vue'], resolve) // 我的
  },
  {
    path: '/recruitList',
    name: 'RecruitList',
    meta: {
      isDoctor: true,
      isGetResearch: true,
      isNavBar: true,
      isFooter: true,
      setMenuActive: 0
    },
    component: (resolve) =>
      require(['../views/recruit/recruitList/index.vue'], resolve) // 招募列表
  },
  {
    path: '/doctorRecruitForm',
    name: 'DoctorRecruitForm',
    meta: {
      isDoctor: true
    },
    component: (resolve) =>
      require(['../views/recruit/doctorRecruitForm/index.vue'], resolve) // 医生端 - 查看患者录入的招募信息
  },
  {
    path: '/rank',
    name: 'Rank',
    meta: {
      isDoctor: true,
      isGetResearch: true,
      isFooter: true,
      isEffectToken: true,
      setMenuActive: 1
    },
    component: (resolve) => require(['../views/rank/index.vue'], resolve) // 消息
  }
]
